module.exports = __webpack_public_path__ + "img/pic-rgzn.6fd93003.png";